import { ArenaLockAction, ArenaLockToolId } from "../constants";
import type { ArenaLockUnlockJobConfig, BuildArenaLockUnlockJobConfigParams } from "../types";

/**
 * Builds the job configuration for Arena Lock/Unlock operations
 * Following the same pattern as Arena Creation's buildToolConfiguration
 *
 * Note: Both lock and unlock operations use the same backend tool type "mark_group_fund_admin"
 * The actual lock/unlock behavior is determined by the TSV file content (group_file parameter)
 */
export function buildArenaLockUnlockJobConfig(
  params: BuildArenaLockUnlockJobConfigParams,
): ArenaLockUnlockJobConfig {
  const { action, tsvFileS3Key, arenaUserEmail, arenaDomain } = params;

  // Both lock and unlock use the same tool type: "mark_group_fund_admin"
  // The toolId can be different to distinguish them in the DAG
  const toolType = "mark_group_fund_admin";
  const toolId =
    action === ArenaLockAction.LOCK ? ArenaLockToolId.LOCK : ArenaLockToolId.UNLOCK;

  // Backend expects only "arena", "user", and "group_file" parameters
  // Note: mark_group_fund_admin.py script does not accept customer_name
  const options = [
    { key: "arena", value: arenaDomain },
    { key: "user", value: arenaUserEmail },
    { key: "group_file", value: tsvFileS3Key },
  ];

  return {
    tools: [
      {
        toolId,
        toolType,
        options,
      },
    ],
  };
}
